export default {
  future: '%s',
  past: '%s temu',
  s: 'kilka sekund',
  ss: '%d sekundy',
  m: 'jedna minuta',
  mm: '%d minuty',
  h: 'jedna godzina',
  hh: '%d godziny',
  d: 'jeden dzień',
  dd: '%d dni',
  M: 'jeden miesiąc',
  MM: '%d miesięcy',
  y: 'rok',
  yy: '%d lat'
};
